import { render, staticRenderFns } from "./cookbookType.vue?vue&type=template&id=6e29d42c&"
import script from "./cookbookType.vue?vue&type=script&lang=js&"
export * from "./cookbookType.vue?vue&type=script&lang=js&"
import style0 from "./cookbookType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports